module.exports = __webpack_public_path__ + "img/zixun8.0460a04a.png";